/* kokoot · PDP v3 display helpers — 1号小哥 2026-06-26 (v2 = 用户反馈4点修正).
 * DISPLAY-ONLY, mobile (≤749px). Touches NO native functionality (no add-to-cart / variant / cart);
 * it only (1) shrinks the NATIVE product title to one line when needed and (2) inserts a green
 * marketing label RIGHT AFTER the NATIVE price (.price) so they share one row.
 * Native product-title / product-price blocks are untouched & stay editor-editable.
 * Badge hide + title base size (24px) + spacing live in CSS (KK_PDP_V3 block in kokoot-pdp-v11.css).
 * Loaded on PDP only (layout/theme.liquid, inside request.page_type=='product').
 */
(function () {
  if (window.__kkPdpV3) return;
  window.__kkPdpV3 = 1;

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function findTitleEl(info) {
    var w = info.querySelector("[class*='kokoot_title']");
    if (!w) return null;
    return w.querySelector('h1, h2, h3') || w.querySelector("[role='heading']") || w;
  }

  // Short titles keep the CSS base (24px, bigger). Only shrink when the title overflows one line,
  // floor 11px — never ellipsis / never truncate. Resets first so a widened viewport regrows the title.
  function fitTitle(t) {
    if (!t) return;
    t.style.setProperty('white-space', 'nowrap', 'important');
    t.style.removeProperty('font-size');                 // back to CSS base (24px) before measuring
    var fs = parseFloat(getComputedStyle(t).fontSize) || 24;
    var guard = 0;
    while (t.scrollWidth > t.clientWidth + 1 && fs > 11 && guard < 60) {
      fs -= 0.5;
      t.style.setProperty('font-size', fs + 'px', 'important'); // must beat CSS !important base
      guard++;
    }
  }

  function addPromoLabel(info) {
    // live default PDP price = native <product-price>; kokoot-pdp template may wrap with kokoot_price — try both
    var pw = info.querySelector('product-price') || info.querySelector("[class*='kokoot_price']");
    if (!pw || pw.querySelector('.kkpdp-b2g')) return;
    var b = document.createElement('span');
    b.className = 'kkpdp-b2g';
    b.setAttribute('aria-hidden', 'true'); // pure marketing display; real B2G1 is Shopify's automatic discount
    b.textContent = '🎁 Buy 2 Get 1 Free';
    var priceEl = pw.querySelector('.price');
    if (priceEl) priceEl.insertAdjacentElement('afterend', b); // sit on the SAME row as the price
    else pw.appendChild(b);
  }

  function run() {
    var info = document.querySelector('.product-information');
    if (!info) return;
    addPromoLabel(info);                 // label fine at any width
    if (isMobile()) fitTitle(findTitleEl(info));
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  // Tinker morphs the product-information subtree on variant change → re-apply.
  document.addEventListener('variant:update', run);
  document.addEventListener('variant:selected', run);
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(run, 150); });
})();
